import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute, renderRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const analyticsShell = lazyWithRetry(() => import("./routes/index"));
const analyticsDashboard = lazyWithRetry(() => import("./routes/dashboard"));
const analyticsActivity = lazyWithRetry(() => import("./routes/activity-log"));
const analyticsReportsIndex = lazyWithRetry(() => import("./routes/reports"));
const analyticsCustomers = lazyWithRetry(() => import("./routes/customers"));
const analyticsTraffic = lazyWithRetry(() => import("./routes/traffic"));
const analyticsConversion = lazyWithRetry(() => import("./routes/conversion"));

const analyticsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/analytics",
  component: () =>
    renderProtectedRoute(analyticsShell, { requirePerms: ["analytics:read"] }),
});

const analyticsDashboardRoute = createRoute({
  getParentRoute: () => analyticsRoute,
  path: "dashboard",
  component: () => renderRoute(analyticsDashboard),
});

const analyticsActivityRoute = createRoute({
  getParentRoute: () => analyticsRoute,
  path: "activity-log",
  component: () => renderProtectedRoute(analyticsActivity, { requirePerms: ["settings:read"] }),
});

const analyticsReportsRoute = createRoute({
  getParentRoute: () => analyticsRoute,
  path: "reports",
  component: () => renderProtectedRoute(analyticsReportsIndex, { requirePerms: ["customers:read"] }),
});

export const analyticsRouteTree = [
  analyticsRoute,
  analyticsDashboardRoute,
  analyticsActivityRoute,
  analyticsReportsRoute,
  createRoute({ getParentRoute: () => analyticsRoute, path: "customers", component: () => renderRoute(analyticsCustomers) }),
  createRoute({ getParentRoute: () => analyticsRoute, path: "traffic", component: () => renderRoute(analyticsTraffic) }),
  createRoute({ getParentRoute: () => analyticsRoute, path: "conversion", component: () => renderRoute(analyticsConversion) }),
];
